import { Transforms } from 'slate';
import { getListType, getParentListItem, getPrevSibling } from "../lib/index.js";
export function mergeListWithPreviousSiblingList(editor, _ref) {
  var [node, path] = _ref;

  if (!editor.isListNode(node)) {
    // This function does not know how to normalize other nodes.
    return false;
  }

  var previousSibling = getPrevSibling(editor, path);

  if (!previousSibling) {
    // Nothing to merge with.
    return false;
  }

  var [previousSiblingNode] = previousSibling;

  if (!editor.isListNode(previousSiblingNode)) {
    return false;
  }

  var isNestedList = Boolean(getParentListItem(editor, path));
  var isPreviousSiblingSameListType = getListType(editor, previousSiblingNode) === getListType(editor, node);

  if (!isPreviousSiblingSameListType && !isNestedList) {
    // If previous sibling "list" is of a different type, then this fix does not apply
    // unless we're working with nested "lists".
    return false;
  }

  Transforms.mergeNodes(editor, {
    at: path
  });
  return true;
}